/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_Day_AInputs */

const en_platform_plan_day_a = /** @type {(inputs: Platform_Plan_Day_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day A`)
};

const pl_platform_plan_day_a = /** @type {(inputs: Platform_Plan_Day_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień A`)
};

/**
* | output |
* | --- |
* | "Day A" |
*
* @param {Platform_Plan_Day_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_day_a = /** @type {((inputs?: Platform_Plan_Day_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_Day_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_day_a(inputs)
	return en_platform_plan_day_a(inputs)
});